module.exports = __webpack_public_path__ + "assets/img/title_ch4_news-item-0.065984ce.png";